import { render } from "./RequestCallLogs.vue?vue&type=template&id=60ebd884"
import script from "./RequestCallLogs.vue?vue&type=script&lang=js"
export * from "./RequestCallLogs.vue?vue&type=script&lang=js"

import "./RequestCallLogs.vue?vue&type=style&index=0&id=60ebd884&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__